<template>
  <div class="hello">
    <img alt="Vue logo" src="../assets/logo.png">
    <h1>{{ msg }}</h1>
    <p>
      This Website is built with
      <a href="https://zouyaoji.top/vue-cesium/#/zh-CN" target="_blank" rel="noopener">Vue for Cesium</a>.
    </p>
    <h4>The purpose of the website is only for testing, if there is any violation of copyright, please let me know and it will be removed as soon as possible</h4>
    <ul>
      <li>Last Updated: 2023/08/02 <a href="mailto:cch1@outlook.com?subject=About%20your%20content%20of%20website&body=Hi%20there%0A%0A">發郵件給我</a></li>
    </ul>
    <h3>API Reference</h3>
    <ul>
      <li><a href="https://cesium.com/platform/cesiumjs/ion-sdk/" target="_blank" rel="noopener">Cesium ion SDK</a></li>
      <li><a href="https://cesium.com/learn/ion-sdk/ref-doc/" target="_blank" rel="noopener">Cesium ion SDK Doc</a></li>
      <li><a href="https://zouyaoji.top/vue-cesium/#/zh-CN/component/vc-viewer" target="_blank" rel="noopener">Vue for Cesium 開發指南</a></li>
    </ul>
    <h3>Essential Links</h3>
    <ul>
      <li><a href="https://cesium.com/" target="_blank" rel="noopener">The Platform for 3D Geospatial</a></li>
      <li><a href="https://zouyaoji.top/vue-cesium/#/zh-CN" target="_blank" rel="noopener">Vue for Cesium</a></li>
    </ul>
    <h3>Ecosystem</h3>
    <ul>
      <li><a href="https://router.vuejs.org" target="_blank" rel="noopener">vue-router</a></li>
      <li><a href="https://vuex.vuejs.org" target="_blank" rel="noopener">vuex</a></li>
      <li><a href="https://github.com/vuejs/vue-devtools#vue-devtools" target="_blank" rel="noopener">vue-devtools</a></li>
      <li><a href="https://vue-loader.vuejs.org" target="_blank" rel="noopener">vue-loader</a></li>
      <li><a href="https://github.com/vuejs/awesome-vue" target="_blank" rel="noopener">awesome-vue</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
